import { isNil } from '../../util/object';
import { DEFAULT_FILL_COLOR } from '../../constants';

export default class MediaSegmentView {
  _backgroundColor = DEFAULT_FILL_COLOR;
  _backgroundStyle;
  _scaleMode;
  _shouldPan = false;
  _startCenterX = 0;

  /**
   * @typedef {Object} MediaSegmentViewWireObject
   * @param {String} background_color
   * @param {String} background_style
   * @param {boolean} should_pan
   * @param {String} scale_mode
   * @param {number} start_center_x
   */

  /**
   * @function
   * @param  {MediaSegmentViewWireObject} mediaSegmentViewWireObject
   * @return {MediaSegmentView}
   */
  constructor(mediaSegmentViewWireObject) {
    if (isNil(mediaSegmentViewWireObject)) return;
    const {
      background_color: backgroundColor,
      background_style: backgroundStyle,
      scale_mode: scaleMode,
      should_pan: shouldPan,
      start_center_x: startCenterX,
    } = mediaSegmentViewWireObject;

    this._backgroundColor = backgroundColor;
    this._backgroundStyle = backgroundStyle;
    this._scaleMode = scaleMode;
    this._shouldPan = shouldPan;
    this._startCenterX = startCenterX;
  }

  get backgroundColor() {
    return this._backgroundColor;
  }
  get backgroundStyle() {
    return this._backgroundStyle;
  }
  get scaleMode() {
    return this._scaleMode;
  }
  get shouldPan() {
    return this._shouldPan;
  }
  get startCenterX() {
    return this._startCenterX;
  }

  set startCenterX(startCenterX) {
    this._startCenterX = startCenterX;
  }

  static isMediaSegmentView(inputObject) {
    return inputObject instanceof MediaSegmentView;
  }
}
